export const getImageVariant = ({ breakpoint, coverPicture, coverPictureNarrow, coverPictureWide, disableCoverPicture, showContent, }) => {
    var _a;
    const coverPictureUrls = {
        l: showContent ? coverPicture : coverPictureWide,
        m: showContent ? coverPictureNarrow : coverPictureWide,
        s: coverPicture,
        xl: showContent ? coverPicture : coverPictureWide,
    };
    const coverPictureUrl = (_a = coverPictureUrls[breakpoint]) !== null && _a !== void 0 ? _a : coverPicture;
    const showPicture = Boolean(!disableCoverPicture && coverPictureUrl);
    return {
        coverPictureUrl,
        showPicture,
    };
};
//# sourceMappingURL=getImageVariant.js.map